export type WorkflowRuntimeMode = "graph_dry_run" | "internal_test"

export function workflowRuntimeUrl(workflowId: number | string | null | undefined, mode: WorkflowRuntimeMode): string | null {
  if (workflowId === null || workflowId === undefined || workflowId === "") return null
  return `/workflows/${encodeURIComponent(String(workflowId))}/${mode}`
}

export function runtimeEndpointNotFoundMessage(mode: WorkflowRuntimeMode): string {
  return mode === "graph_dry_run"
    ? "Dry Run endpoint was not found. The workflow runtime routes may not be deployed correctly."
    : "Internal Test endpoint was not found. The workflow runtime routes may not be deployed correctly."
}

export async function workflowRuntimeResponseMessage(response: Response): Promise<string> {
  const text = await response.text()
  if (!text) return response.statusText || "Workflow test request failed."

  try {
    const json = JSON.parse(text) as { summary?: string; message?: string; error?: string; errors?: string[] }
    return json.summary || json.message || json.error || json.errors?.join(", ") || text
  } catch {
    return text
  }
}
